/**
 * Pure helper to compute a safe Gmail web URL for a thread, derived only
 * from the thread id the provider already supplies — no extra API call.
 */
export function buildGmailWebUrl(threadId?: string): string {
  if (!threadId || !threadId.trim()) return '';
  return `https://mail.google.com/mail/u/0/#all/${encodeURIComponent(threadId.trim())}`;
}
